module.exports = "/_next/static/images/shirsh-98ed6caf40abaeb4526200f0ba271128.png";